<template>
    <div class="app-main" id="order-index">
        <el-row type="flex" class="app-main-header" align="middle">
            <el-col :span="6">
                <div class="router-title">
                    <i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
                </div>
            </el-col>
        </el-row>
        <el-card class="box-card mg-b5">
            <div class="el-menu-box">
                <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect">
                    <el-menu-item
                        v-for="item in menus"
                        :key="item.key"
                        :index="item.key">
                            {{item.name}}
                            {{item.count?`(${item.count})`:''}}
                    </el-menu-item>
                </el-menu>
            </div>
        </el-card>
        <div class="order-wrap">
            <OrderTable  v-if="activeIndex == 'all'" pageFlag="all" />
            <OrderTable  v-if="activeIndex == 'waitAffirm'" pageFlag="waitAffirm" />
            <OrderTable  v-if="activeIndex == 'isAffirm'" pageFlag="isAffirm" />
            <OrderTable  v-if="activeIndex == 'hasPlan'" pageFlag="hasPlan" />
            <OrderTable  v-if="activeIndex == 'signInCus'" pageFlag="signInCus" />
            <OrderTable  v-if="activeIndex == 'inStoreCus'" pageFlag="inStoreCus" />
            <OrderTable  v-if="activeIndex == 'invoiceCus'" pageFlag="invoiceCus" />
        </div>
    </div>
</template>
<script>
import OrderTable from '../OrderTable'
import { queryOrderStatic } from '@/api/omg/index.js';
export default {
    components:{
        OrderTable
    },
    data(){
        return {
            activeIndex:'',
            menus:[
                {key:'all',name:'全部',count:''},
                {key:'waitAffirm',name:'待确认',count:''},
                {key:'isAffirm',name:'已确认',count:''},
                {key:'hasPlan',name:'发货计划',count:''},
                {key:'signInCus',name:'已签收',count:''},
                {key:'inStoreCus',name:'已入库',count:''},
                {key:'invoiceCus',name:'已开票',count:''},
            ],
        }
    },
    created(){
        this.activeIndex = 'all'
        queryOrderStatic({}).then(({data:res}) => {
            if(res.code == 0){
                let curmenus = [...this.menus];
                let datas = res.data.statistics;
                datas.forEach(item => {
                    if(item.code == -1){
                        curmenus[0].count = item.count + ''
                    }else{
                        curmenus[item.code].count = item.count + ''
                    }
                })
                this.menus = [...curmenus]
            }
        })
    },
    methods:{
        handleSelect(key){
            console.log(key)
            this.activeIndex = key;
        },
    },
}
</script>
<style lang="scss">
    #order-index{
        .el-menu-box{
            width:100%;
        }
    }
</style>
